import { Card, Stack, Typography } from '@mui/material';
import { CardFragment as CardData } from 'generated/graphql';
import ActionButton from './ActionButton';
import BtnIcon from './BtnIcon';

const IconCard = ({
  data,
  hideButton = false,
  onClick,
  disabled = false,
  loading = false,
}: {
  data: CardData;
  hideButton?: boolean;
  onClick: () => void;
  disabled?: boolean;
  loading?: boolean;
}) => {
  return (
    <Card
      elevation={0}
      sx={(theme) => ({
        display: 'flex',
        flexDirection: 'row',
        backgroundColor: data.color,
        gap: 1,
        marginY: theme.spacing(1),
      })}
    >
      <BtnIcon icon={data.icon} />
      <Stack>
        <Typography
          variant="body1"
          sx={(theme) => ({ fontWeight: theme.typography.fontWeightBold, paddingX: theme.spacing(1) })}
        >
          {data.title}
        </Typography>
        <Typography
          variant="body1"
          sx={(theme) => ({
            fontWeight: theme.typography.fontWeightRegular,
            color: theme.palette.grey[800],
            paddingX: theme.spacing(1),
          })}
        >
          {data.description}
        </Typography>
        {!hideButton && (
          <ActionButton
            {...data.button}
            size="medium"
            disabled={disabled || data.button.disabled}
            loading={loading}
            sx={(theme) => ({
              padding: theme.spacing(0.1, 1),
              minWidth: 'min-content',
              whiteSpace: 'nowrap',
              alignSelf: 'start',
            })}
            onClick={onClick}
          />
        )}
      </Stack>
    </Card>
  );
};

export default IconCard;
